// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.add-ticket-success-modal__highlighted-text {\n  color: var(--color-primary);\n  color: var(--color-secondary);\n}\n", ""]);
// Exports
module.exports = exports;
